import React from 'react';
import { Box, CircularProgress } from '@mui/material';

import CompleteIcon from '@/assets/icons/circle-thick-check.svg?react';
import palette from '@/theme/palette';

type ProgressProps = {
  value?: number;
  size?: 'large' | 'small';
};

const ProcessProgress = ({ size = 'large', value = 0 }: ProgressProps) => {
  const sizeNum = size === 'large' ? 20 : 16;

  return value < 100 ? (
    <Box position="relative">
      <CircularProgress
        sx={{ display: 'block' }}
        type="process-buffer"
        variant="determinate"
        thickness={5.5}
        value={100}
        size={sizeNum}
      />
      <CircularProgress
        type="process"
        variant="determinate"
        value={value}
        size={sizeNum}
        thickness={5.5}
        sx={{ position: 'absolute', insetInlineStart: 0, top: 0, display: 'block' }}
      />
    </Box>
  ) : (
    <CompleteIcon width={sizeNum + 2} height={sizeNum + 2} display="block" color={palette.primary.main} />
  );
};

export default ProcessProgress;
